import { type JSX, Show } from 'solid-js';
import { t } from '../i18n';
import type { SessionWorth } from '../lib/sessionWorth';

// The session header's token line (#2490 follow-on): how many tokens this run
// spent and what they are WORTH at OpenRouter list rates.
//
// WHY THE LABEL IS NOT "cost". We are BYOK — the customer's key pays the
// provider and we never resell tokens — and on prod 2026-08-27, 151M tokens
// across the flat-rate and box-subscription lanes cost exactly $0.00. Rendering
// that zero told a maintainer nothing; rendering a dollar sign next to the word
// "cost" would tell them something false. So the figure is captioned as a
// reference against a public rate card, and the note under it says outright that
// we never charge for tokens. Presenter only — every decision is
// `sessionWorth`'s.

export function SessionWorthLine(props: { readonly worth: SessionWorth | null }): JSX.Element {
  return (
    <Show when={props.worth} keyed>
      {(w) => (
        <p class="session-worth">
          <span class="session-worth__tokens">
            {t('session_worth.tokens', { count: w.tokens.toLocaleString() })}
          </span>{' '}
          <Show
            when={w.kind === 'listed' ? w : null}
            keyed
            // Every absence renders its OWN sentence rather than a shared dash:
            // "no OpenRouter listing for this model" and "no tokens recorded" send
            // a reader to opposite conclusions, and one of them is actionable.
            fallback={
              <span class="session-worth__absent">
                {t(w.kind === 'absent' ? w.reasonKey : 'session_worth.unknown')}
              </span>
            }
          >
            {(listed) => (
              <span class="session-worth__value" title={t('session_worth.note')}>
                {t('session_worth.value', { amount: listed.amount })}
              </span>
            )}
          </Show>
        </p>
      )}
    </Show>
  );
}
